<script setup lang="ts">import { toRef as _toRef } from 'vue';

import { useScreen } from '@consumer/helpers/screen'

import { useWindowScroll } from '@vueuse/core'

import CartMenu from './Header/CartMenu.vue'
import CategoryBar from './Header/CategoryBar.vue'
import FavoritesMenu from './Header/FavoritesMenu.vue'
import GiftlyLogo from './Header/GiftlyLogo.vue'
import MainContainer from './Header/MainContainer.vue'
import UserMenu from './Header/UserMenu.vue'
import Overlay from './Overlay.vue'
import OmniSearch from './Header/OmniSearch.vue'

defineOptions({
  inheritAttrs: false,
})

defineEmits(['close'])

const __$temp_1 = (useScreen()),
  isDesktop = _toRef(__$temp_1, 'isDesktop');
const __$temp_2 = (useWindowScroll()),
  y = _toRef(__$temp_2, 'y');
const scrolled = computed(() => y.value > 150)
</script>

<template>
  <div
    v-bind="$attrs"
    class="fixed top-0 w-full z-navbar bg-white"
    :class="scrolled && 'lg:shadow-v2md'"
  >
    <V2Container class="!p-0 w-full">
      <Transition name="slide-down">
        <MainContainer v-show="isDesktop || (!isDesktop && !scrolled)" withSearchBar>
          <div class="w-full flex items-center justify-between h-15">
            <GiftlyLogo/>

            <div class="hidden lg:block flex-grow px-15">
              <OmniSearch/>
            </div>

            <div class="flex items-center gap-2 lg:gap-4">
              <FavoritesMenu/>
              <CartMenu/>
              <UserMenu/>
            </div>
          </div>
        </MainContainer>
      </Transition>
      <div class="lg:hidden">
        <OmniSearch :scrolled="scrolled"/>
      </div>
    </V2Container>
  </div>

  <div class="h-[127.5px] lg:h-[84px]"/>

  <CategoryBar/>

  <Overlay/>
</template>
